import React from "react";
import { Text, Select } from "@jsq/ds/core";
import { FIELD_CONTAINER_STYLE } from "./constants";
import { BankMappingSelectProps } from "./types";

/**
 * BankMappingSelect component renders a dropdown for selecting a bank mapping
 * from available bank sources.
 *
 * @component
 * @example
 * ```tsx
 * <BankMappingSelect
 *   label="Bank mapping for Fides"
 *   value={fidesBankMapping}
 *   onChange={handleBankMappingChange}
 *   bankSources={fidesBankSources}
 *   testId="fides-bank-mapping-select"
 *   width="60%"
 * />
 * ```
 */
export const BankMappingSelect: React.FC<BankMappingSelectProps> = ({
  label,
  value,
  onChange,
  bankSources,
  testId,
  width = "100%",
  error,
}) => {
  const handleChange = (val: string | number | (string | number)[]) => {
    onChange(val ? String(val) : null);
  };

  return (
    <div style={{ ...FIELD_CONTAINER_STYLE, width }}>
      <Text variant="strong-sm">{label}</Text>
      <Select
        placeholder="Select bank"
        value={value ?? ""}
        onChange={handleChange}
        full
        data-testid={testId}
        error={error}
      >
        <Select.Section>
          {bankSources.map((source) => (
            <Select.Option key={source.bankSource} value={source.bankSource}>
              {source.bankSource.replace(/_/g, " ")}
            </Select.Option>
          ))}
        </Select.Section>
      </Select>
    </div>
  );
};
